export default {
  name: 'KTimeline',
  provide() {
    return {
      context: this,
    }
  },
  props: {
    thin: {
      type: Boolean,
      default: false,
    },
    dotPlacement: {
      type: String,
      default: null,
    },
    joinLine: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  render() {
    const css = {
      'km-timeline': true,
      'km-timeline--thin': this.thin,
    }

    const data = {
      class: css,
    }

    return (
      <div {...data}>
        {this.$slots.default}
      </div>
    )
  }
  ,
}
